import { render } from "./BAvailablePeriod.vue?vue&type=template&id=2980a876&scoped=true"
import script from "./BAvailablePeriod.vue?vue&type=script&lang=js"
export * from "./BAvailablePeriod.vue?vue&type=script&lang=js"

import "./BAvailablePeriod.vue?vue&type=style&index=0&id=2980a876&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2980a876"

export default script